import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { collection, query, where, getDocs, limit } from 'firebase/firestore'
import { db } from '../lib/firebase'

export default function PopularDestinations() {
  const { t } = useTranslation()
  const [destinations, setDestinations] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadDestinations()
  }, [])

  const loadDestinations = async () => {
    try {
      const q = query(
        collection(db, 'destinations'),
        where('featured', '==', true),
        limit(4)
      )
      const snapshot = await getDocs(q)
      const destinationsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
      setDestinations(destinationsData)
    } catch (error) {
      console.error('Error loading destinations:', error)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <section className="popular-destinations">
        <div className="container">
          <h2>{t('popularDestinations.title', 'Điểm Đến Phổ Biến')}</h2>
          <div className="loading">{t('common.loading', 'Đang tải...')}</div>
        </div>
      </section>
    )
  }

  return (
    <section className="popular-destinations">
      <div className="container">
        <h2>🗺️ {t('popularDestinations.title', 'Điểm Đến Phổ Biến')}</h2>
        <div className="destinations-grid">
          {destinations.map(dest => (
            <Link key={dest.id} to={`/destinations`} className="destination-card">
              <div className="destination-image">
                <img src={dest.imageUrl || 'https://picsum.photos/600/400'} alt={dest.name} />
                <div className="destination-overlay">
                  <h3>{dest.name}</h3>
                  <p>{dest.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
        {destinations.length === 0 && (
          <p className="no-destinations">{t('popularDestinations.noDestinations', 'Chưa có điểm đến nào')}</p>
        )}
      </div>

      <style>{`
        .popular-destinations {
          padding: 80px 24px;
          background: white;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .popular-destinations h2 {
          text-align: center;
          font-size: 2.5rem;
          margin-bottom: 48px;
          color: #1f2937;
        }

        .destinations-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 24px;
        }

        .destination-card {
          text-decoration: none;
          color: white;
          border-radius: 16px;
          overflow: hidden;
          transition: all 0.3s;
        }

        .destination-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
        }

        .destination-image {
          position: relative;
          height: 300px;
          overflow: hidden;
        }

        .destination-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s;
        }

        .destination-card:hover .destination-image img {
          transform: scale(1.1);
        }

        .destination-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 24px;
          background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
        }

        .destination-overlay h3 {
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 8px;
        }

        .destination-overlay p {
          opacity: 0.9;
        }

        .loading, .no-destinations {
          text-align: center;
          padding: 60px;
          color: #6b7280;
          font-size: 1.1rem;
        }

        @media (max-width: 768px) {
          .destinations-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </section>
  )
}

